import React, { useEffect, useState } from "react";
import useAuth0 from "@common/Auth0Provider/use-auth0";
import { Box, Typography } from "@mui/material";

const LogoutSplashScreen: React.FC = () => {
  const { loginWithRedirect } = useAuth0();
  const [seconds, setSeconds] = useState(10);

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((prev) => prev - 1);
    }, 1000);
    const timeout = setTimeout(() => {
      loginWithRedirect();
    }, 10000);
    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [loginWithRedirect]);

  return (
    <Box
      className={
        "h-[100vh] w-full bg-[#D7F3FF] justify-center items-center flex flex-col gap-2"
      }
    >
      <img src={require("@assets/OrganoxLogo.png")} alt={"logo"} />
      <Typography>You can now login with your new password</Typography>
      <Box className="flex">
        <Typography className="pl-1 text-[#0077B2] cursor-pointer ">
          Redirecting to login in {seconds} second{seconds !== 1 ? "s" : ""}
        </Typography>
      </Box>
    </Box>
  );
};

export default LogoutSplashScreen;
